module.exports = __webpack_public_path__ + "img/BrokenClouds.d506850f.png";